import { jsx as x } from "react/jsx-runtime";
import { forwardRef as y, useMemo as v } from "react";
import N from "classnames";
import t from "./index.es5508.js";
const P = y(
  ({
    type: d,
    size: e,
    variant: i,
    isUnderlined: m,
    isEllipsis: f,
    children: l,
    color: r = "primary",
    element: o = "span",
    role: p,
    testId: s,
    ...n
  }, b) => {
    const c = N(t.text, t[`color-${r}`], {
      [t.underlined]: m,
      [t.ellipsis]: f
    }), u = v(() => {
      const a = {
        "data-pl-type": d,
        "data-pl-role": p,
        "data-pl-size": e,
        "data-pl-variant": i
      };
      return s && (a["data-testid"] = s), e || delete a["data-pl-size"], i || delete a["data-pl-variant"], a;
    }, [d, p, e, i, s]);
    return /* @__PURE__ */ x(
      o,
      {
        ...n,
        ...u,
        className: c,
        ref: b,
        "aria-label": o === "label" ? l : void 0,
        "aria-hidden": r === "disabled",
        "aria-disabled": r === "disabled",
        children: l
      }
    );
  }
);
export {
  P as TextPrimitive
};
//# sourceMappingURL=index.es761.js.map
